module.exports = __webpack_public_path__ + "scripts/gradient.svg?79f1951d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error/gradient.svg
// module id = 1323
// module chunks = 1